import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import TextEditor, { TEXT_EDITOR_VARIANTS } from 'ui/TextEditor';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

import StatusLabel from '../shared/StatusLabel';
import { useClearNotificationEffect } from '../shared/hooks';

const ARIA_BASE = 'report_card_header';

function SettingsReportCardHeader(props) {
  const [defaultValue, setDefaultValue] = useState(props.reportCardHeaderText);
  const [isError, setIsError] = useState();
  const [isSuccess, setIsSuccess] = useState();

  const clearSetIsSuccess = useCallback(() => {
    setIsSuccess(false);
  }, []);

  useClearNotificationEffect(isSuccess, null, clearSetIsSuccess);

  const onChange = useCallback(text => {
    const updates = { report_card_header_text: text || null };
    setIsError(false);

    request
      .patchJSON(routes.SETTINGS.UPDATE_COMPANY, { company: updates })
      .then(() => {
        setDefaultValue(setDefaultValue);
        setIsSuccess(true);
      })
      .catch((response, statusText, err) => {
        console.error(err, response);
        setIsError(true);
      });
  }, []);

  return (
    <div>
      <div className="d-f ai-c lh-24 mb-8">
        <label className="mb-0" htmlFor={ARIA_BASE}>
          {t('settings.tab.global_lesson.report_card_header_text')}
        </label>
        <StatusLabel
          id={`${ARIA_BASE}_status`}
          success={isSuccess}
          error={isError}
        />
      </div>
      <TextEditor
        id={ARIA_BASE}
        variant={TEXT_EDITOR_VARIANTS.SIMPLE}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </div>
  );
}

SettingsReportCardHeader.propTypes = {
  reportCardHeaderText: PropTypes.string,
};

export default SettingsReportCardHeader;
